// extracted by mini-css-extract-plugin
export var component = "ModuleWrapper-module--component--wymBT";
export var header = "ModuleWrapper-module--header--Wukkj";
export var title = "ModuleWrapper-module--title--3q3uO";